import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  async download(event) {
    if (event.defaultPrevented) return

    event.preventDefault()
    const url = `${this.element.action}?${new URLSearchParams(new FormData(this.element))}`

    mdFormHelper.showSpinner()
    try {
      const response = await fetch(url)
      this.save(await response.blob(), this.filename(response))
    } finally {
      mdFormHelper.hideSpinner()
    }
  }

  save(blob, name) {
    const href = URL.createObjectURL(blob)
    const link = Object.assign(document.createElement("a"), { href, download: name })
    document.body.appendChild(link)
    link.click()
    link.remove()
    URL.revokeObjectURL(href)
  }

  filename(response) {
    return decodeURIComponent(response.headers.get("Content-Disposition").match(/filename\*=UTF-8''(.+)/)[1])
  }
}
